import { useEffect, useState } from 'react';

export const enum VIEWPORT_TYPE {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

export const useViewport = () => {
  const [viewport, setViewport] = useState<VIEWPORT_TYPE>();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      switch (true) {
        case width >= 1128:
          setViewport(VIEWPORT_TYPE.Desktop);
          break;
        case width >= 768:
          setViewport(VIEWPORT_TYPE.Tablet);
          break;
        default:
          setViewport(VIEWPORT_TYPE.Mobile);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { viewport };
};
